import React from "react";
import NavItem from "../../NavItem/NavItem";
import NavMenu from "../../NavMenu/NavMenu";
import { LinksContainerStyled, PermissionsContainer } from "./LinksContainerStyles";
const LinksContainer = ({ links, closeMenu, displayEnvIndicator, displayPermissionsIndicator, displayStatusIndicator, permissions = "", customLinkComponent, }) => {
    return (React.createElement(LinksContainerStyled, { displayEnvIndicator: displayEnvIndicator, displayStatusIndicator: displayStatusIndicator },
        displayPermissionsIndicator && !!permissions?.length && (React.createElement(PermissionsContainer, null, permissions)),
        links.map((link) => {
            if (link.subLinks?.length) {
                return (React.createElement(NavMenu, { ...link, onClick: () => {
                        if (!!link.onClick) {
                            link.onClick();
                        }
                        closeMenu();
                    }, customLinkComponent: customLinkComponent, key: link.name }));
            }
            else {
                return (React.createElement(NavItem, { ...link, onClick: () => {
                        if (!!link.onClick) {
                            link.onClick();
                        }
                        closeMenu();
                    }, customLinkComponent: customLinkComponent, key: link.name }));
            }
        })));
};
export default LinksContainer;
//# sourceMappingURL=LinksContainer.js.map